/**
 * Predefined subscription plan features for Bandhan Guru vendors.
 * These labels match the enforced controls in Bandhan_Guru_Nodejs/src/utils/planFeatures.js
 */
export const OTHER_FEATURE_VALUE = "__other__";

/** Tier-specific feature bullets — auto-applied when admin creates a plan by tier name. */
export const TIER_PLAN_FEATURES = {
  basic: [
    "Listed on Bandhan Guru platform",
    "Customer contact details visible",
    "Up to 3 service categories",
    "Up to 30 customer leads per month",
    "Basic profile analytics",
    "GST invoice on every payment",
    "Wallet coins usable up to 25% of plan price",
    "Email support (Basic)",
  ],
  standard: [
    "Everything in Basic, plus:",
    "Photo & gallery upload (up to 10 images)",
    "Up to 10 service categories",
    "Up to 150 customer leads per month",
    "WhatsApp promotion via influencers",
    "Up to 2 promotion posts per month",
    "Standard analytics dashboard",
    "Phone & chat support",
  ],
  premium: [
    "Everything in Standard, plus:",
    "Priority listing — top search placement",
    "Social media promotion (Reels & Blogs)",
    "Unlimited service categories",
    "Unlimited customer leads",
    "Up to 25 gallery images",
    "Up to 5 promotion posts per month",
    "Full analytics & conversion tracking",
    "Dedicated account manager support",
  ],
};

export const PREDEFINED_PLAN_FEATURES = [
  ...TIER_PLAN_FEATURES.basic,
  ...TIER_PLAN_FEATURES.standard.filter((f) => !f.startsWith("Everything")),
  ...TIER_PLAN_FEATURES.premium.filter((f) => !f.startsWith("Everything")),
];

/** Allowed billing durations in admin panel — no weekly plans. */
export const ALLOWED_PLAN_UNITS = [
  { value: "month", label: "Month (3 or 6 months)" },
  { value: "year", label: "Year (1 year)" },
];

export const ALLOWED_PLAN_DURATIONS = [
  { duration: 3, unit: "month", label: "3 Months" },
  { duration: 6, unit: "month", label: "6 Months" },
  { duration: 1, unit: "year", label: "1 Year" },
];
